import React from 'react';
import { motion } from 'framer-motion';
import { OpenFpgaLogo } from '../OpenFpgaLogo';
import { SlideLayout } from '../SlideLayout';
import { ArrowRight } from 'lucide-react';
export function TitleSlide({
  isActive
}: {
  isActive: boolean;
}) {
  return <SlideLayout slideNumber={1} totalSlides={20} hideLogo data-id="element-521">
      <div className="flex flex-col items-center justify-start pt-8 md:pt-12 h-full text-center pb-24" data-id="element-522">
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-8 md:mb-12" data-id="element-523">
          <OpenFpgaLogo size="xl" data-id="element-524" />
        </motion.div>

        <motion.h1 initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-4 md:mb-6 tracking-tight" data-id="element-525">
          The AI Inference Landscape
        </motion.h1>

        <motion.p initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="text-lg md:text-2xl lg:text-3xl text-brand-primary font-medium mb-6 md:mb-8" data-id="element-526">
          Why FPGAs Are the Winning Architecture
        </motion.p>

        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.7,
        duration: 0.6
      }} className="max-w-2xl mx-auto px-2" data-id="element-527">
          <p className="text-base md:text-lg lg:text-xl text-brand-muted leading-relaxed" data-id="element-528">
            Better latency, better power efficiency, no vendor lock-in. Access
            the world's most powerful programmable hardware.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.2,
        duration: 1,
        repeat: Infinity,
        repeatType: 'reverse'
      }} className="absolute bottom-20 text-brand-muted flex flex-col items-center gap-2" data-id="element-529">
          <span className="text-sm font-mono" data-id="element-530">
            Press Right Arrow or Click to Start
          </span>
          <ArrowRight className="w-5 h-5 rotate-90 md:rotate-0" data-id="element-531" />
        </motion.div>
      </div>
    </SlideLayout>;
}